import { Extension, InputRule } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { Slice, Fragment } from 'prosemirror-model';
import escapeRegExp from 'lodash/escapeRegExp';
/**
 * Inserts extra newline when pasting paragraphs
 */ const pastePlugin = new Plugin({
    key: new PluginKey('DaDamzPastePlugin'),
    props: {
        handlePaste: (view, event, slice)=>{
            const { schema } = view.state;
            const paragraphType = schema.nodes.paragraph;
            const nodes = [];
            slice.content.forEach((node, offset, index)=>{
                nodes.push(node);
                // Insert an extra empty paragraph after each paragraph (except the last one)
                if (node.type === paragraphType && index < slice.content.childCount - 1) {
                    const emptyParagraph = paragraphType.createAndFill();
                    if (emptyParagraph) {
                        nodes.push(emptyParagraph);
                    }
                }
            });
            if (nodes.length === slice.content.childCount) {
                return false;
            }
            const newFragment = Fragment.fromArray(nodes);
            const newSlice = new Slice(newFragment, slice.openStart, slice.openEnd);
            const tr = view.state.tr.replaceSelection(newSlice);
            view.dispatch(tr);
            return true;
        }
    }
});
const emoteMap = {
    '>:(': '😠',
    '>:-(': '😠',
    ':")': '😊',
    ':-")': '😊',
    '</3': '💔',
    '<\\3': '💔',
    ':/': '😕',
    ':-/': '😕',
    ":'(": '😢',
    ":'-(": '😢',
    ':,(': '😢',
    ':,-(': '😢',
    ':(': '☹️',
    ':-(': '☹️',
    '<3': '❤️',
    ']:(': '😈',
    ']:-(': '😈',
    'o:)': '😇',
    'O:)': '😇',
    'o:-)': '😇',
    'O:-)': '😇',
    '0:)': '😇',
    '0:-)': '😇',
    ":')": '😂',
    ":'-)": '😂',
    ':,)': '😂',
    ':,-)': '😂',
    ":'D": '😂',
    ":'-D": '😂',
    ':,D': '😂',
    ':,-D': '😂',
    ':*': '😘',
    ':-*': '😘',
    'x-)': '😆',
    'X-)': '😆',
    ':|': '😐',
    ':-|': '😐',
    ':o': '😮',
    ':-o': '😮',
    ':O': '😮',
    ':-O': '😮',
    ':@': '😡',
    ':-@': '😡',
    ':D': '😀',
    ':-D': '😀',
    ':)': '🙂',
    ':-)': '🙂',
    ']:)': '😏',
    ']:-)': '😏',
    ":,'(": '😭',
    ":,'-(": '😭',
    ';(': '😭',
    ';-(': '😭',
    ':P': '😛',
    ':-P': '😛',
    '8-)': '😎',
    'B-)': '😎',
    ',:(': '😓',
    ',:-(': '😓',
    ',:)': '😅',
    ',:-)': '😅',
    ':s': '😒',
    ':-S': '😒',
    ':z': '😒',
    ':-Z': '😒',
    ':$': '😒',
    ':-$': '😒',
    ';)': '😉',
    ';-)': '😉'
};
const emoteVariants = Object.keys(emoteMap);
const escapedEmoteVariants = emoteVariants.map(escapeRegExp);
const regex = new RegExp(`(^|\\s)(${escapedEmoteVariants.join('|')})$`, 'g');
/**
 * Replaces basic emotes with emojis
 */ const emojiInputRule = new InputRule({
    find: regex,
    handler: ({ state, range, match })=>{
        const { tr } = state;
        const prefix = match[1];
        const emote = match[2];
        const emoji = emoteMap[emote];
        if (!emoji) {
            return null;
        }
        // Replace the matched text (including any preceding space) with the prefix and emoji.
        tr.insertText(prefix + emoji, range.from, range.to);
    }
});
/**
 * Special plugin just for damz which is a "plaintext" editor
 */ export const DaDamz = Extension.create({
    name: 'da-damz',
    addProseMirrorPlugins () {
        return [
            pastePlugin
        ];
    },
    addInputRules () {
        return [
            emojiInputRule
        ];
    }
});

//# sourceMappingURL=damz.js.map